/* eslint-disable global-require */
module.exports = ['artmarketinsight.reports.m16', 'artmarketinsight.reports.m17'];
